<portals-navbar></portals-navbar>
<div class="bg-[#491176] flex flex-col items-center justify-center min-h-screen pb-[76px]">
	<h1 class="text-[#FBD354] !text-5xl !font-extrabold">
		Thank you for
		<br />
		choosing Jotto!
	</h1>
	<h3 class="text-center text-white !text-2xl !font-normal">
		Your purchase was successful, and we’re excited to
		<br />
		have you on board. An email with your login
		<br />
		credentials and setup instructions will be sent to you shortly.
		<br />
		<br />
		You can use these credentials to access your Jotto
		<br />
		dashboard and start creating channels, prompts,
		<br />
		and engaging with your community.
	</h3>
	<div class="text-center flex flex-col items-center mt-4">
		<h2 class="text-[#FBD354] !text-5xl !font-bold" style="font-family: 'Roboto', sans-serif">Get in touch anytime</h2>

		<h3 class="text-white !text-2xl !font-normal">
			If you need any help getting started or have any
			<br />
			questions, our support team is here for you. Check
			<br />
			your inbox for the next steps and let’s get started on
			<br />
			gathering valuable insights together!
			<br />
			<br />
			Thank you for being a part of Jotto!
		</h3>
		<img src="/assets/images/qr-code-yellow.png" loading="lazy" class="image" alt="QR Code" />
		<button (click)="goToSendMessage()" class="submit-button rounded-xl font-bold" style="background-color: #fbd354; color: #491176; border-radius: 100px">Scan QR or Click Here</button>
	</div>
</div>
